import { useState } from 'react';
import { yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { useBidRange } from './useBidRange';
import { useOrderStore } from 'store/orderStore';
import { useCampaignStore } from 'store/campaignStore';
import { getBasicValidationSchema } from './validationSchemas';

interface initialKeywords {
  defaultForm: any;
  newForm: any;
}

const useDisplayValidation = (
  initialState: initialKeywords = { defaultForm: {}, newForm: {} },
) => {
  const { defaultForm, newForm } = initialState;
  const { order } = useOrderStore();
  const { actionType } = useCampaignStore();
  const bidRange = useBidRange();
  const [errors, setErrors] = useState<any>({ basic: {}, products: '' });

  const commonSchema = getBasicValidationSchema({
    defaultForm,
    actionType,
    order,
    bidRange,
  });

  const validationSchema = Yup.object().shape({
    basic: commonSchema,
  });

  // 即時驗證表單
  const handleValidation = () => {
    validationSchema
      .validate(newForm, { abortEarly: false })
      .then(() => setErrors({}))
      .catch((err) => {
        setErrors(yupToFormErrors(err));
      });
  };

  return { validationSchema, errors, setErrors, handleValidation };
};

export default useDisplayValidation;
